import { Fragment, h } from "preact";
import { useEffect, useLayoutEffect, useState } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";

import AppHeader from "../components/AppHeader.jsx";
import AppLayout from "../components/AppLayout.jsx";
import BlocksLoadingIndicator from "../components/BlocksLoadingIndicator.jsx";
import Button from "../components/Button.jsx";
import FilterBar from "../components/FilterBar.jsx";
import Icon from "../components/Icon.jsx";
import TaskFilter from "../components/TaskFilter.jsx";
import TaskList from "../components/TaskList.jsx";
import TaskListAddition from "../components/TaskListAddition.jsx";
import TaskProgressFilter from "../components/TaskProgressFilter.jsx";
import Hint from "../components/HintContainer.jsx";
import WaitingListModal from "../components/WaitingListModal.jsx";

import { taskState } from "../helpers";
import i18n from "../i18n.js";
import {
  fetchTasks,
  selectCTAs,
  selectCurrentUser,
  selectTasks,
  setHideFullTaskList,
  setLoading,
} from "../store/index";

function createFilterForObjective(value) {
  return function (task) {
    return value ? task.objective === value : true;
  };
}

function createFilterForProgress(value) {
  return function (task) {
    if (!value) return true;

    return value === taskState(task);
  };
}

export default function TasksPage() {
  const [showHandleButton, setShowHandleButton] = useState(false);
  const hideFullTaskList = useSelector((state) => state.ui.hideFullTaskList);
  const currentUser = useSelector(selectCurrentUser);
  const dispatch = useDispatch();

  const tasks = useSelector(selectTasks);
  const ctas = useSelector(selectCTAs);
  const selectedProgressFilter = useSelector(
    (state) => state.ui.taskProgressFilter
  );
  const selectedFilter = useSelector((state) => state.ui.taskFilter);

  useEffect(async () => {
    window.scrollTo(0, 0);
    dispatch(setLoading(true));
    dispatch(fetchTasks());
    dispatch(setLoading(false));
  }, []);

  const filteredTasks = tasks
    .filter(createFilterForObjective(selectedFilter))
    .filter(createFilterForProgress(selectedProgressFilter));

  function handleShowLists() {
    dispatch(setHideFullTaskList(false));
  }
  useLayoutEffect(() => {
    setTimeout(() => {
      setShowHandleButton(true);
    }, 3000);
  }, []);

  return (
    <Fragment>
      <AppLayout
        header={
          <AppHeader
            title={i18n.t("pages.titles.tasks")}
            filterBar={
              <FilterBar>
                <TaskProgressFilter />
                <TaskFilter tasks={tasks} />
              </FilterBar>
            }
          />
        }
        headerWithFilter
      >
        <div>
          <Hint />
          <TaskList
            tasks={hideFullTaskList ? filteredTasks.slice(0, 1) : filteredTasks}
            user={currentUser}
          />

          {hideFullTaskList && tasks.length > 1 && (
            <div class="tasks-page__first-task-action">
              <Icon big class="mt-48 mb-32">
                first_task
              </Icon>
              {showHandleButton ? (
                <Button onClick={handleShowLists}>
                  Show complete tasklist
                </Button>
              ) : (
                <img src="/images/tasks_loading.gif" />
              )}
            </div>
          )}
          <TaskListAddition tasks={tasks} ctas={ctas} />
        </div>
      </AppLayout>
      <div class="nioomi-modal-wrapper">
        <WaitingListModal />
      </div>
    </Fragment>
  );
}
